import React, {useContext, useMemo, useState} from 'react';
import {
  MetaFieldType, ReqAPIDataType, testConfirmationData, testErrorData, ErrorDataType,
  SelectedMFType, ShopifyContextType, testTaxConfigData, TaxConfigDataType, AppDataType, testAppData
} from '../models/AppModel';
//default Shopify Context
export const defaultShopifyContext = {
  reqAPIData: testConfirmationData,//default required API Data
  setReqAPIData: () => {},
  errorData: testErrorData,//default error data
  setErrorData: () => {},
  metaFields:[],//default empty metaFields
  setMetaFields: () => {},
  codeFlexFieldList: [],//default empty code FlexField List
  numericMetaFieldsList: [],//default empty numeric MetaFields List
  dateMetaFieldsList: [],//default empty date MetaFields List
  setCodeFlexFieldList: () => {},
  setNumericMetaFieldsList: () => {},
  setDateMetaFieldsList: () => {},
  selectedMetaFlexFieldsList: [],//default empty selected MetaFields List
  setSelectedMetaFlexFieldsList: () => {},
  selectedMFFF: [],//for selected MFFF Data
  setSelectedMFFF: () => {},
  taxConfigData: testTaxConfigData,
  setTaxConfigData: () => {},
  productClassMFList: [],//default empty list for Product Class Table
  setProductClassMFList: () => {},
  appData: testAppData,
  setAppData:() => {}
};

interface Props {
  children: React.ReactNode;//App Context Props Type
}
//Context lets the parent component make some information available to any component 
//in the tree below it—no matter how deep—without passing it explicitly through props.
export const AppDataContext = React.createContext<ShopifyContextType>(defaultShopifyContext);
//Wrap your components into a context provider to specify the value of this context
// for all components inside:
export const AppContextProvider: React.FC<Props> = ({children}) => {
  //context state for req API Data
  const [reqAPIData, setReqAPIData] = useState<ReqAPIDataType>(testConfirmationData);
  //context state for error Data
  const [errorData, setErrorData] = useState<ErrorDataType>(testErrorData);
  //context state for MF Data
  const [metaFields, setMetaFields] = useState<MetaFieldType[]>([]);
  //context state for Code MF Data
  const [codeFlexFieldList, setCodeFlexFieldList] = useState<MetaFieldType[]>([]);
  //context state for Numeric MF Data
  const [numericMetaFieldsList, setNumericMetaFieldsList] = useState<MetaFieldType[]>([]);
  //context state for Date MF Data
  const [dateMetaFieldsList, setDateMetaFieldsList] = useState<MetaFieldType[]>([]);
  //context state for Selected MF Data
  const [selectedMetaFlexFieldsList, setSelectedMetaFlexFieldsList] = useState<SelectedMFType[]>([]);
  const [selectedMFFF, setSelectedMFFF] = useState<SelectedMFType[]>([]);
  //context state for Tax Configuration
  const [taxConfigData, setTaxConfigData] = useState<TaxConfigDataType>(testTaxConfigData);
  //context state for Product Class MF Data
  const [productClassMFList, setProductClassMFList] = useState<MetaFieldType[]>([]);
  const AppProviderValue= useMemo(() => ({
    reqAPIData, setReqAPIData
  }), [reqAPIData, setReqAPIData]);
  //context state for APP Data
  const [appData, setAppData] = useState<AppDataType>(testAppData);
  return (
    <AppDataContext.Provider value={{
      ...AppProviderValue,
      errorData,setErrorData,
      metaFields,setMetaFields,
      codeFlexFieldList,setCodeFlexFieldList,
      numericMetaFieldsList,setNumericMetaFieldsList,
      dateMetaFieldsList,setDateMetaFieldsList,
      selectedMetaFlexFieldsList, setSelectedMetaFlexFieldsList,
      selectedMFFF, setSelectedMFFF,
      taxConfigData, setTaxConfigData,
      productClassMFList, setProductClassMFList,
      appData, setAppData
    }}>
      {children}
    </AppDataContext.Provider>
  );
};

export const useAppContext: () => ShopifyContextType = () => useContext(AppDataContext);
